import { CARD_TYPE_MAP, LeadCardType } from './cardTypes';

export const URL_SLUG_BY_CARD_TYPE: Record<LeadCardType, string> = {
  [CARD_TYPE_MAP.matchingSuites]: 'suites',
  [CARD_TYPE_MAP.invitation]: 'invitations',
  [CARD_TYPE_MAP.std]: 'save-the-date',
  [CARD_TYPE_MAP.dstd]: 'digital/save-the-date',
  [CARD_TYPE_MAP.ctd]: 'change-the-date',
  [CARD_TYPE_MAP.thankyou]: 'thank-you-cards',
  [CARD_TYPE_MAP.menu]: 'menus',
  [CARD_TYPE_MAP.program]: 'programs',
  [CARD_TYPE_MAP.place]: 'place-cards',
  [CARD_TYPE_MAP.details]: 'enclosures',
  [CARD_TYPE_MAP.enclosure]: 'enclosures',
  [CARD_TYPE_MAP.holiday]: 'holiday-cards',
  [CARD_TYPE_MAP.weddingShower]: 'bridal-shower',
  [CARD_TYPE_MAP.napkin]: 'napkins',
  [CARD_TYPE_MAP.signage]: 'signage',
  [CARD_TYPE_MAP.sticker]: 'stickers',
  [CARD_TYPE_MAP.tableNumber]: 'table-numbers',
  [CARD_TYPE_MAP.paperAddOns]: 'paper-add-ons',
  [CARD_TYPE_MAP.bellyBand]: 'paper-add-ons',
  [CARD_TYPE_MAP.vellumJacket]: 'paper-add-ons',
  [CARD_TYPE_MAP.waxSeal]: 'paper-add-ons',
} as const;
